// extracted by mini-css-extract-plugin
export var card_header = "index-module--card_header--2c4cb";
export var card_title = "index-module--card_title--fb7d4";
export var custom = "index-module--custom--ee550";
export var desc = "index-module--desc--00634";
export var free = "index-module--free--062ef";
export var ja = "index-module--ja--31383";
export var off_tag = "index-module--off_tag--c1868";
export var pro = "index-module--pro--fd147";
export var team = "index-module--team--8b169";
export var title_text = "index-module--title_text--1aaf3";